import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63d34747"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "featured" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_list" }
const _hoisted_4 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_image = _resolveComponent("a-image")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 数字人应用场景展示 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            ref_for: true,
            ref: "item",
            class: _normalizeClass(["item", [`i_${index+1}`,index+1===$data.expand.active?'active':'']])
          }, [
            _createVNode(_component_a_typography_title, { level: 5 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, (v) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_a_image, {
                  alt: "",
                  src: v.image
                }, null, 8 /* PROPS */, ["src"]),
                _createCommentVNode(" {{ v.text }} ")
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 2 /* CLASS */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _createCommentVNode(" <a-space :size=\"$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'\">\n        <a-button type=\"link\" class=\"button_n_3\" @click=\"clickToAidigitalHuman()\">\n          免费试用\n        </a-button>\n        <a-button class=\"button_n_2\"  type=\"link\" \n                 @click=\"$Store.Page().openModal('modalFormCollection','productAidigitalHuman')\">\n         联系我们\n        </a-button>\n      </a-space> ")
    ])
  ]))
}